export default {
  helpText: 'Vyberte a zoraďte stĺpce, ktoré chcete zobraziť v tabuľke prehľadu objednávok. Toto nastavenie platí globálne pre všetkých používateľov.',
  selectedColumns: 'Vybrané stĺpce',
  nonSelectedColumns: 'Dostupné stĺpce',
};
